export default "__VITE_ASSET__CJINvLz9__"